import { importPopupModule } from "./importPopupModule";
import { WinGISMap } from "../../createMap";

export async function processIdentifyResults(identifyResults) {
    let foundFeatures = [];
    let popupPromises = [];
    identifyResults.forEach((idenResults) => {
        idenResults.results.map(result => {
            popupPromises.push(importPopupTemplate(result, idenResults.originLayer))
        });
        idenResults.results.forEach((result) => {
            result.originLayer = idenResults.originLayer;
            foundFeatures.push(result.feature);
        });
    });
    
    foundFeatures.sort((a, b) => a.layerId - b.layerId);
    
    await Promise.all(popupPromises);
    return foundFeatures;
}



function importPopupTemplate (result, originLayer) {
    const feature = result.feature;
    if (feature?.attributes?.OptOut == "Y")
    {
      const layerName = result.layerName;
      feature.attributes.layerName = layerName;
  
      feature.popupTemplate = {
        title: layerName,
        content: "This parcel has opted out of WinGIS services."
      }
  
      return feature;

    }
    else {
      return importPopupModule(originLayer).then(featureModule => {
        const layerName = result.layerName;
        feature.attributes.layerName = layerName;
    
        const popup = featureModule(feature, result, WinGISMap.view);
        feature.popupTemplate = typeof popup === 'string' ? {
          title: layerName,
          content: popup
        } : popup;
    
        return feature;
      }).catch(error => console.error("Error importing search module:", error));     
    }
  }